import { tv } from "../../variants/tv.js";
const baseAutocompleteVariants = tv({
    slots: {
        rootSlot: 'relative flex flex-col gap-1',
        overlayInputSlot: 'relative mt-1 grid w-full grid-cols-[48px_1fr] gap-3 px-4 pb-4',
        popupSlot: 'bg-neutral-1 max-h-[370px] w-[var(--anchor-width)] min-w-[464px] overflow-y-auto overflow-x-hidden overscroll-contain rounded-xl shadow-lg outline-none',
        positionerSlot: 'z-1',
        listSlot: 'flex flex-col gap-0 p-1',
        emptySlot: 'text-primary-11 flex h-16 items-center justify-center px-4 py-2',
        groupLabelSlot: 'text-primary-13 h-8 pb-1 pl-3 pt-2 text-sm font-medium',
        iconSlot: 'flex items-center justify-center'
    },
    variants: {
        isMobile: {
            true: {
                popupSlot: 'h-full max-h-none w-full shadow-none'
            }
        }
    }
});
export { baseAutocompleteVariants };
